/**
 * Chấm công và lịch sử công của chính nhân viên.
 *
 * Việc GỬI một lần chấm công KHÔNG nằm ở đây — nó ở `lib/queue.ts`, vì mọi
 * lần chấm công phải vào hàng đợi trước rồi mới thử gửi (docs/01 §1.8). Tệp
 * này chỉ lo phần đọc và phần lấy nonce.
 */

import { request } from '../api/client'
import type { Challenge, NgayCong } from '../types'

export const layChallenge = () =>
  request<Challenge>('/attendance/challenge', { method: 'POST' })

export interface LichSuThang {
  days: NgayCong[]
  work_hours?: number
  travel_hours?: number
}

export const layLichSu = (thang: string) =>
  request<LichSuThang>(`/attendance/me?month=${encodeURIComponent(thang)}`)

/**
 * Tự kiểm tra điều kiện chấm công — server nói lại nó THẤY gì từ máy này.
 *
 * Kiểu trả về để cho màn hình gọi tự khai: hình dạng phản hồi bám sát những
 * gì `attendance.py::tu_kiem_tra` trả về và còn thay đổi theo từng đợt, nên
 * khai cứng ở đây chỉ tạo ra hai bản mô tả phải giữ cho khớp nhau.
 */
export const layTuKiemTra = <T = Record<string, unknown>>() =>
  request<T>('/attendance/tu-kiem-tra')
